import React from 'react'
import './styles.css'
import styled from 'styled-components'

const MainDiv = styled.div`
  background: linear-gradient(121.87deg, #3b49bf 36.03%, #575ea0 100%);
  position: relative;
  text-align: center;
  color: #ffffff;
  font-family: 'Mukta';
  padding-bottom: 40px;
  min-height: 72vh;

  display: flex;
  align-items: center;
  justify-content: center;
`

const EarningsInfoDiv = styled.div`
  width: 80%;
  margin: 10px auto;
  border-radius: 12px;
  border: 0.5px solid #fff;
  background: linear-gradient(
    94deg,
    rgba(255, 255, 255, 0.06) -0.03%,
    rgba(255, 255, 255, 0.16) 99.1%
  );

  hr {
    border-top: 0.5px solid rgba(255, 255, 255, 0.5);
  }

  div {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 16px;
  }
`

const AuthorImages = styled.img`
  width: 90%;
  margin: 6px auto;
`

const EarningsInfoCoin = styled.img`
  width: 6%;
`

const EarningsInfoText = styled.div`
  color: #fff;
  font-size: 12px;
  span {
    font-weight: 700;
  }
`

const CoinAndEarnDiv = styled(EarningsInfoDiv)`
  margin: 20px auto;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  padding: 10px 16px;
  font-weight: 700;

  img {
    width: 48px;
  }
`

const InnerContent = styled.div``

const BingerInvite = ({ bingerExpVaraint }) => {
  return (
    <MainDiv>
      <img
        className="pattern rightPattern"
        src="https://djhonz7dexnot.cloudfront.net/16079a48b7d01b4315d1c36d17b125329f751290.png"
        alt=""
      />
      <img
        className="pattern bottomPattern"
        src="https://djhonz7dexnot.cloudfront.net/16079a48b7d01b4315d1c36d17b125329f751290.png"
        alt=""
      />
      {bingerExpVaraint === 'A' && (
        <InnerContent>
          <h3 className="inviteTitle">बनिए सफल लेखक, अच्छी आमदनी के साथ</h3>
          <h6 className="inviteSubtitle">
            कुल <span>2,450</span> हमारे पूर्व-पाठक आज है <span>सफल लेखक</span>{' '}
            और साथ ही पाते है <span>अच्छी आमदनी</span>
          </h6>
          <AuthorImages
            src="https://djhonz7dexnot.cloudfront.net/b31ab7a127ad48241efc975c1daaa9cf392dcdbd.png"
            alt=""
          />
        </InnerContent>
      )}
      {bingerExpVaraint === 'B' && (
        <InnerContent>
          <h3 className="inviteTitle">बनिए सफल लेखक, अच्छी आमदनी के साथ</h3>
          <h6 className="inviteSubtitle">
            कुल <span>2,450</span> हमारे पूर्व-पाठक आज है <span>सफल लेखक</span>{' '}
            और साथ ही पाते है <span>अच्छी आमदनी</span>
          </h6>
          <AuthorImages
            src="https://djhonz7dexnot.cloudfront.net/b31ab7a127ad48241efc975c1daaa9cf392dcdbd.png"
            alt=""
          />
          <CoinAndEarnDiv>
            <img
              src="https://djhonz7dexnot.cloudfront.net/d61461df87842319ed0266f17e6012ac4b333069.png"
              alt=""
            />
            <div>Earn 100 Coins When You Write Your First Chapter</div>
          </CoinAndEarnDiv>
        </InnerContent>
      )}
      {bingerExpVaraint === 'C' && (
        <InnerContent>
          <h3 className="inviteTitle">बनिए सफल लेखक, अच्छी आमदनी के साथ</h3>
          <h6 className="inviteSubtitle">
            कुल <span>2,450</span> हमारे पूर्व-पाठक आज है <span>सफल लेखक</span>{' '}
            और साथ ही पाते है <span>अच्छी आमदनी</span>
          </h6>
          <AuthorImages
            src="https://djhonz7dexnot.cloudfront.net/b31ab7a127ad48241efc975c1daaa9cf392dcdbd.png"
            alt=""
          />
          <CoinAndEarnDiv>
            <img
              src="https://djhonz7dexnot.cloudfront.net/d61461df87842319ed0266f17e6012ac4b333069.png"
              alt=""
            />
            <div>Earn 1,000 Coins When You Write Your First Chapter</div>
          </CoinAndEarnDiv>
        </InnerContent>
      )}
      {bingerExpVaraint === 'D' && (
        <InnerContent>
          <h3 className="inviteTitle">बनिए सफल लेखक, अच्छी आमदनी के साथ</h3>
          <h6 className="inviteSubtitle">
            कुल <span>2,450</span> हमारे पूर्व-पाठक आज है <span>सफल लेखक</span>{' '}
            और साथ ही पाते है <span>अच्छी आमदनी</span>
          </h6>
          <AuthorImages
            src="https://djhonz7dexnot.cloudfront.net/2a85602d4b864ad37ac6079c9b3037b95ac4ed35.png"
            alt=""
          />
          <AuthorImages
            src="https://djhonz7dexnot.cloudfront.net/1c5f50baaea9b63ea4c0b6ba2953832dec58c8df.png"
            alt=""
          />
          <EarningsInfoDiv>
            <div><h4>Publish Your First Chapter</h4> </div>
            <hr />
            <EarningsInfoText>
              Within Next 2 Days & Earn &nbsp;
              <EarningsInfoCoin
                src="https://djhonz7dexnot.cloudfront.net/3004f5a39ecf27a3b3e73406ab5ab890e789467d.png"
                alt=""
              />
              <EarningsInfoCoin
                src="https://djhonz7dexnot.cloudfront.net/3004f5a39ecf27a3b3e73406ab5ab890e789467d.png"
                alt=""
              />
              <EarningsInfoCoin
                src="https://djhonz7dexnot.cloudfront.net/3004f5a39ecf27a3b3e73406ab5ab890e789467d.png"
                alt=""
              />
              &nbsp;
              <span>1,000</span>
            </EarningsInfoText>
            <hr />
            <EarningsInfoText>
              Between 2 to 15 Days & Earn&nbsp;
              <EarningsInfoCoin
                src="https://djhonz7dexnot.cloudfront.net/3004f5a39ecf27a3b3e73406ab5ab890e789467d.png"
                alt=""
              />
              <EarningsInfoCoin
                src="https://djhonz7dexnot.cloudfront.net/3004f5a39ecf27a3b3e73406ab5ab890e789467d.png"
                alt=""
              />
              &nbsp;
              <span>500</span>
            </EarningsInfoText>
            <hr />
            <EarningsInfoText>
              After 15 Days & Earn&nbsp;{' '}
              <EarningsInfoCoin
                src="https://djhonz7dexnot.cloudfront.net/3004f5a39ecf27a3b3e73406ab5ab890e789467d.png"
                alt=""
              />
              &nbsp;
              <span>100</span>
            </EarningsInfoText>
          </EarningsInfoDiv>
        </InnerContent>
      )}
    </MainDiv>
  )
}

export default BingerInvite
